import { PageHeader } from "../components/Common";
import { AssetLibrary } from "../components/AssetLibrary";
import { useAuth } from "../lib/auth";

export default function AssetsPage() {
  const { account } = useAuth();
  return (
    <div>
      <PageHeader overline="Media" title="Media Library" desc="Organise this entity's images in folders. Click an image to view it, rename it, move it or copy its link." />
      <AssetLibrary scope="account" lab={!!account?.is_lab} />
    </div>
  );
}
